module.exports = __webpack_public_path__ + "img/teaching-3.b1fb3d38.png";